import { EmptyStateOnboarding } from "@octopusdeploy/design-system-components";
import { AnalyticLinkLocationProvider } from "@octopusdeploy/portal-analytics";
import type { ComponentProps } from "react";
type PortalEmptyStateOnboardingProps = ComponentProps<typeof EmptyStateOnboarding>;
export function PortalEmptyStateOnboarding(props: PortalEmptyStateOnboardingProps) {
    return (<AnalyticLinkLocationProvider location={"Onboarding Page"}>
            <EmptyStateOnboarding {...props}/>
        </AnalyticLinkLocationProvider>);
}
